import PatientSourceManagement from 'components/pages/setup/PatientSourceManagement/PatientSourceManagement';

import { PATIENT_SOURCE_MANAGEMENT } from '../../../../constants/accessToPages';

export const patientSourceManagementRouterConfig = {
  name: 'Patient Source Management',
  path: '/patient-source-management',
  component: PatientSourceManagement,
  access: [PATIENT_SOURCE_MANAGEMENT]
};
